import type { MeetingDoc } from "../../../services/meetingDocsEndpoint";

export type MeetingViewFilter = "all" | "my" | "shared";

export type MeetingDisplayMode = "list" | "board";

export type MeetingBoardGroupBy = "time_group" | "action" | "company";

export type MeetingTimeGroup = "Coming up" | "Today" | "Yesterday" | "Earlier";

export type MeetingActionType = "prep" | "follow_up" | "followed_up";

export type MeetingDateFilter = "all" | "upcoming" | "today" | "past";

export type MeetingActionFilter = "all" | "needs_action" | "followed_up" | "none";

export type MeetingAttendee = {
  name: string;
  initials: string;
};

export type MeetingCompany = {
  name: string;
  domain?: string;
};

export type MeetingAction = {
  type: MeetingActionType;
  label: string;
};

export type MeetingPrepStatus = "pending" | "running" | "success" | "failed";

export type MeetingRowData = {
  id: string;
  title: string;
  timeLabel: string;
  group: MeetingTimeGroup;
  company: MeetingCompany | null;
  action: MeetingAction | null;
  attendees: MeetingAttendee[];
  hasRecording: boolean;
  hasNotes: boolean;
  when: Date | null;
  searchableText: string;
  prepStatus?: MeetingPrepStatus;
  followupStatus?: MeetingPrepStatus;
  prepRunId?: string;
  prepBrief?: string | null;
  doc?: MeetingDoc;
  prepDoc?: MeetingDoc;
  followupDoc?: MeetingDoc;
};

export const MEETING_GROUP_ORDER: readonly MeetingTimeGroup[] = [
  "Coming up",
  "Today",
  "Yesterday",
  "Earlier",
] as const;
